export default {"src":"/_next/static/media/illustration-paw.7509eea3.svg","height":120,"width":120};